import { appContainer } from '../../contexts/app';
import Resource from '../resource';

// Accounts are pretty locked down on the server
// You can only get, put, and patch from the client
// and they are all locked down to only editing the
// account corresponding to the token in the session
export default (accountService, accountCardService, sessionService) => {
  let currentAccountResource = Resource(
    accountService,
    {
      name: '',
      plan_id: '',
      owner_id: '',
      billing_email: ''
    },
    {
      updateCard(token) {
        return accountCardService.update(null, token);
      }
    }
  );

  currentAccountResource.getCurrentAccount = async () => {
    // Passing null to the .get() method on accounts service will
    // return the account according to the account id in the token.
    // Pass isCurrentAccount because this is the call that actually
    // initally loads currentAccount into state and the setCurrentAccount
    // hook cannot check against it if it doesnt already exist
    return await accountService.get(null, { isCurrentAccount: true });
  };

  currentAccountResource.loadSessions = async () => {
    return await sessionService.find();
  };

  return currentAccountResource;
};

// If we are working on the currentAccount,
// put it in proper place in state also
export const setCurrentAccount = context => {
  const currentAccountId = appContainer.state.getIn(['currentAccount', '_id']);
  if (
    context.params.isCurrentAccount ||
    (context.id === currentAccountId && currentAccountId !== undefined)
  ) {
    appContainer.set('currentAccount', context.result);
  }
};



// WEBPACK FOOTER //
// ./src/feathers/currentAccount/currentAccount.js